import { render, staticRenderFns } from "./ContactSearch.vue?vue&type=template&id=18aaa247&scoped=true&"
import script from "./ContactSearch.vue?vue&type=script&lang=js&"
export * from "./ContactSearch.vue?vue&type=script&lang=js&"
import style0 from "./ContactSearch.vue?vue&type=style&index=0&id=18aaa247&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aaa247",
  null
  
)

export default component.exports